import Icon from '../components/Icon.vue'

Icon.register({
  crow: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 32c53 0 96 28.7 96 64l-96 16v80c0 87.3-58.3 160.8-138 184.1l41.2 111.5c2.3 6.2-0.9 13.1-7.2 15.4l-22.5 8.2c-6.2 2.3-13.1-0.9-15.4-7.2l-44.5-120.4c-1.9 0.1-3.8 0.3-5.7 0.3h-39.1l38.3 103.7c2.3 6.2-0.9 13.1-7.2 15.4l-22.5 8.2c-6.2 2.3-13.1-0.9-15.4-7.2l-44.4-120.1h-96.5l-121.5 60.8c-20.1 10-43.7-4.6-43.7-27 0-8.3 5.4-19.2 12.1-24.2l371.9-292.6v-21c0-44.2 35.8-80 80-80 26.1 0 49 12.7 63.6 32h16.4zM464 104c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crow.js
// module id = 1249
// module chunks = 0